import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import { createHttpLink } from "apollo-link-http"
import { Tabs, Typography, Row, Col, Button, Modal, Icon, Select, Card, Input, InputNumber, message, Spin, Tooltip, Radio } from 'antd'
import { Queries } from '../../../graphql'
import Container from '../../../components/user/Container'
import CardTitle from '../../../components/user/CardTitle'
import { changeOnlyMonthSlip, changeYear, changeFormatdateSlip } from '../../../utils/formatdate'
import { numberWithCommas } from '../../../utils/number'
import { setWithExpiry, getWithExpiry } from '../../../utils/storage'
import { monthDataSet } from '../../../config/datasets'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { ErrorMessageFormAPI } from '../../../utils/checkError'
import { convertToHTMl } from '../../../utils/markDown'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'

import ReactMarkdown from 'react-markdown'
import ReactDom from 'react-dom'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select

const radioStyle = {
    display: 'block',
  };

class Slip extends Component {
	state = {
		detailSlip: null,
		visibleModal: false,
		selectMonth: '',
		selectYear: moment().year(),
		visibleModalCardNo: false,
		ModalCardNoPreLoad: false,
		CardNoOk: false,
		CardNoValue: null,
		CardNoFetch: '',
		preLoad: true,
		preLoadDataSlip: true,
		//////////////////////addmodalINTERNAL_SERVER_ERROR
		showModalErrors: false,
		textPayrollSlip: null,
		detailSlipTax:null,
		organizationShow: false,
		selectOrganization:[],
		profileKey:[],
		organizationName: null,
		tax6Month: null,
		payDate:null,
		listUrlTax:[],
		textMonthOrYear:'เดือน',
		// ListUrlTaxKey:'0',
		ListUrlTaxKey:'',
		switchShowMonthOrSalarCert: 'Month',
		detaSalaryCert: null,
		dropDownSalaryCert: [],
		linkPDFSalary: null,
		detaSalaryCertText: null,
		empCode: '',
		dropDownTypeSalaryCert: null,
		selectTypeSalaryCert: '',
		preLoadSlipSalartCert: false,
      	labelDropdownFile: null,
      	dropDownMasterSlipPayment:[],
		dropdownSelectedDocType: null
	}

	fetchProfile = async () => {
		const { selectOrganization } = this.state

		await this.setState({
			switchShowMonthOrSalarCert: 'Month'
		})
		try {
			const { client } = this.props
			const { data } = await client.query({
				query: Queries.fetchProfile
			})

			if(data.fetchProfile){
				selectOrganization.filter(selectOrganization => selectOrganization.profileKey == data.fetchProfile.currentProfile).map(async filterData => (
					await this.setState({
						organizationName: filterData.workProfile.orgPosition.positionName+' '+filterData.workProfile.orgUnit.orgUnitName+' '+filterData.workProfile.organization.orgName
					})
				))
				await this.setState({
					profileKey: data.fetchProfile.currentProfile,
					empCode: data.fetchProfile.employeeCodes[0]
				})
				// return data.fetchProfile
			}
			
		} catch (e) {
			// message.error('Something went wrong. Please try again')
		}
	}

	fetchSlip = async (monthValue = null) => {
		const { client } = this.props
		const { selectMonth, selectYear, CardNoValue, profileKey } = this.state

		await this.setState({
			visibleModalCardNo: false,
			preLoad: false,
			preLoadDataSlip: false,
			switchShowMonthOrSalarCert: 'Month'
		});

		let month = selectMonth.toString()
		if(monthValue){
			month = monthValue
		}

		console.log('dropDownMasterSlipPayment',selectYear)

		try {
			// console.log("CardNoValue.toString()", CardNoValue.toString());

			const { data, errors } = await client.query({
				query: Queries.fetchSlip,
				variables: {
					month,
					year: selectYear.toString(),
					identityCard: CardNoValue.toString(),
					profileKey
				}
			})
			// console.log('data',data)
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}

			console.log('sadfsadfas',data)

			if (data && !errors) {
				if (CardNoValue) {
					// setWithExpiry("CardNo", CardNoValue, 900000)
				}

				console.log('xxxx1')

				await this.setState({
					detailSlip: data.fetchSlip,
					visibleModalCardNo: false,
					CardNoOk: true,
					CardNoFetch: CardNoValue,
					preLoadDataSlip: true,
					ModalCardNoPreLoad:true
				});

			} else {
				if (errors[0].message == 'Identity Card is incorrect') {
					console.log('xxxx2')
					await this.setState({
						detailSlip: data,
						CardNoOk: false,
						preLoad: true
					});
					// message.error(ErrorMessageFormAPI(errors[0].message))
				}else if(errors[0].extensions.code == 'PASSWORD_DOESNT_MATCH'){
					console.log('xxxx3')
					await this.setState({
						detailSlip: data,
						visibleModalCardNo: true,
						CardNoOk: true,
						CardNoFetch: '',
						preLoadDataSlip:true,
						ModalCardNoPreLoad:false
					});
					// message.error(errors[0].message)
				} else {
					console.log('xxxx4')
					await this.setState({
						detailSlip: data,
						visibleModalCardNo: false,
						CardNoOk: true,
						CardNoFetch: CardNoValue,
						preLoadDataSlip:true,
						ModalCardNoPreLoad:true
					});
				}
			}
		} catch (error) {
			console.log('asfasfasf')
			// const errorMessage = error.graphQLErrors[0].message
			await this.setState({
				CardNoOk: false,
				preLoad: true,
				ModalCardNoPreLoad:true
			});
			// message.error("รหัสผ่านไม่ถูกต้อง")
		}
	}

	fetchSlipPayDate = async() =>{
		const { client } = this.props
		const { profileKey } = this.state
		// console.log('test',profileKey)
		await this.setState({
			visibleModalCardNo: false,
			preLoad: false,
			preLoadDataSlip: false
		});
		try {
			const { selectMonth, selectYear, CardNoValue } = this.state

			const { data, errors } = await client.query({
				query: Queries.fetchSlipPayDate,
				variables: {
					month: moment().format('MM').toString(),
					year: moment().year().toString(),
					identityCard: CardNoValue.toString(),
					profileKey
				}
			})
			
			// let payDate = "2021-06-22T17:00:00.000Z"
			let payDate = null 

			if(data.fetchSlipPayDate){
				payDate = data.fetchSlipPayDate.payDate
				await this.setState({
					payDate
				})
			}


			if(payDate == null){
			console.log('zxczcxzczc')
				await this.setState({
					selectMonth: moment().add(-1, 'month').format('MM'),
					selectYear: moment().year()
				})
			}else if(moment().month() == "00" && parseFloat(moment().date()) >= parseFloat(moment(payDate).date())){
				await this.setState({
					selectMonth: '12', 
					selectYear: moment().year()-1
				})
			}else if(parseFloat(moment().date()) >= parseFloat(moment(payDate).date())){
				await this.setState({
					selectMonth: moment().format('MM'),
					selectYear: moment().year()
				})
			}else{
				await this.setState({
					selectMonth: moment().add(-1, 'month').format('MM'),
				})
			}
		} catch (error) {
			
		}
	}

	fetchUrlTax = async () =>{
		const { client } = this.props
		const { selectMonth, selectYear, CardNoValue, profileKey } = this.state

		try {
			const { data, errors } = await client.query({
				query: Queries.fetchUrlTax,
				variables: {
					month: selectMonth.toString(),
					year: selectYear.toString(),
					identityCard: CardNoValue.toString(),
					profileKey
				}
			})
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}

			if(data.fetchUrlTax.linkPDF){
				window.open(data.fetchUrlTax.linkPDF, "_blank")
			}else{
				message.error("ไม่มีไฟล์ในการแสดงผล")
			}

		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// await this.setState({
			// 	CardNoOk: false,
			// 	preLoad: true,
			// 	ModalCardNoPreLoad:true
			// });
			// message.error("รหัสผ่านไม่ถูกต้อง")
		}
	}

	fetchUrlTax6Month = async (month) =>{
		const { client } = this.props
		const { selectMonth, selectYear, CardNoValue, profileKey } = this.state

		try {
			const { data, errors } = await client.query({
				query: Queries.fetchUrlTax6Month,
				variables: {
					month,
					year: selectYear.toString(),
					identityCard: CardNoValue.toString(),
					profileKey
				}
			})
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}

			if(data.fetchUrlTax6Month){
				window.open(data.fetchUrlTax6Month.linkPDF, "_blank")
			}else{
				message.error("ไม่มีไฟล์ในการแสดงผล")
			}
		} catch (error) {
			console.log(error)
			// const errorMessage = error.graphQLErrors[0].message
			// await this.setState({
			// 	CardNoOk: false,
			// 	preLoad: true,
			// 	ModalCardNoPreLoad:true
			// });
			// message.error("รหัสผ่านไม่ถูกต้อง")
		}
	}

	fetchUrlSlip = async () => {
		const { client } = this.props
		const { selectMonth, selectYear, CardNoValue, profileKey } = this.state
		const { data, errors } = await client.query({
			query: Queries.fetchUrlSlip,
			variables: {
				month: selectMonth.toString(),
				year: selectYear.toString(),
				identityCard: CardNoValue.toString(),
				profileKey
			}
		})
		//////////////////////addmodalINTERNAL_SERVER_ERROR
		if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
			await this.setState({
				showModalErrors: true
			})
		}
		window.open(data.fetchUrlSlip.linkPDF, "_blank")
	}

	fetchUrlTaxYears = async () =>{
		try {
			const { client } = this.props
			const { selectMonth, selectYear, CardNoValue, profileKey } = this.state
			const { data, errors } = await client.query({
				query: Queries.fetchUrlTaxYears,
				variables: {
					month: '12',
					year: selectYear.toString(),
					identityCard: CardNoValue.toString(),
					profileKey
				}
			})
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}

			console.log(data)
			window.open(data.fetchUrlTaxYears.linkPDF, "_blank")
		} catch (e) {
			// message.error('Something went wrong. Please try again')
		}
	}

	fetchSlipOpenLink = async () =>{
		const { ListUrlTaxKey } = this.state
		
		if(ListUrlTaxKey == '0'){
			this.fetchUrlSlip()
		}else if(ListUrlTaxKey == '1'){
			this.fetchUrlTaxYears()
		}else if(ListUrlTaxKey == '2'){
			this.fetchUrlTax()
		}else if(ListUrlTaxKey == '3'){
			this.fetchUrlTax6Month('6')
		}else if(ListUrlTaxKey == '4'){
			this.fetchUrlTax6Month('12')
		}
	}

	fetchHowToOpenPayrollSlip = async () =>{
        const { client } = this.props
        try {
            const { date } = this.state
            const { data, errors } = await client.query({
                query: Queries.howToOpenPayrollSlip,
            })

			await this.setState({
				textPayrollSlip:data.howToOpenPayrollSlip
			})

        } catch (error) {
            console.log(error)
        }
    }

	showModal = async () => {
		await this.setState({
			visibleModal: true,
		});
	};

	handleCancel = async () => {
		// await this.fetchSlip()
		await this.setState({ visibleModal: false });
	};

	handleOk = async (dropdownSelectedDocType) => {
		await this.setState({
			visibleModal: false,
			preLoadDataSlip: false
		});
		await this.dropDownSlipPayment()

		// 50 ทวิ
		if (dropdownSelectedDocType == '1') {
			//await this.dropDownMasterSlipPayment(dropdownSelectedDocType)
			await this.fetchSlip('1-12')
		} 
		// 40(6) Jan-Jun
		else if (dropdownSelectedDocType == '3') {
			await this.fetchSlip('1-6')
		} 
		// 40(6) Jul-Dec
		else if (dropdownSelectedDocType == '4') {
			await this.fetchSlip('7-12')
		} else {
			await this.fetchSlip()
		}
	};

	onChangeMonth = async (value) => {
		const { selectMonth } = this.state
		let newsValue = '';
		if (value < 9) {
			newsValue = '0' + (value + 1);
			await this.setState({
				selectMonth: newsValue
			})
		} else {
			newsValue = (value + 1).toString();
			await this.setState({
				selectMonth: newsValue
			})
		}

	}

	onChangeYear = async (value) => {
		await this.setState({
			selectYear: value
		})
	}

	checkMonthDisabled = (value) =>{
		const { selectYear, selectMonth, payDate } = this.state

		if(selectYear !== moment().year()){
			return false
		}else if(selectYear === moment().year() && value < moment().month()){
			return false
		}else if(payDate == null && selectYear === moment().year() && value === moment().month()){
			return true
		}else if(selectYear === moment().year() && value === moment().month() && parseFloat(moment().date()) >= parseFloat(moment(payDate).date()) ){
			return false
		}else{
			return true
		}
	}

	accordingProfile = async () => {
		const { client } = this.props
		const { profile } = this.state
		try {
			const { data, errors } = await client.query({
				query: Queries.accordingProfile,
			})
			if (data.accordingProfile.length > 1) {
				await this.setState({
					organizationShow: true,
					selectOrganization: data.accordingProfile
				})
			}
		} catch (error) {
			console.log('error', error)
		}
	}

	modalSelectMonth = () => {
		const { 
               visibleModal, 
               selectMonth, 
               selectYear, 
               ListUrlTaxKey, 
               textMonthOrYear,
               dropDownMasterSlipPayment 
         } = this.state

      let optionDropDownYear = [
         {
            id: moment().year(),
            label: changeYear(moment().year())
         },
          {
            id: moment().year() - 1,
            label: changeYear(moment().year() - 1)
         },
      ]
		return <>
			{/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
			{
				this.state.showModalErrors &&
				<ModalErrors />
			}
			{/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
			<Modal
				destroyOnClose={false}
				visible={visibleModal}
				closable={false}
				title={ textMonthOrYear == 'เดือน' ? "เดือน / ปี" : "ปี"}
				onOk={() => this.handleOk(this.state.dropdownSelectedDocType)}
				// onCancel={this.handleCancel}
				footer={[
					<Button key="submit" type="primary" onClick={() => this.handleOk(this.state.dropdownSelectedDocType)} className="color-white">
						ตกลง
					</Button>
				]}
					>
						{
							( ListUrlTaxKey == '0' ||  ListUrlTaxKey == '2') &&
							<div className="mb-4">
							<Text>
								เลือกเดือน
							</Text><br></br>
							<Select
								// defaultValue={moment(selectMonth).month()}
								defaultValue={ selectMonth <= 9 ? selectMonth.substring(1)-1 : selectMonth-1 }
								style={{ width: '100%' }}
								onChange={this.onChangeMonth}
							>
								{
									monthDataSet.map((valueMonth, keysMonth) =>
										<Option value={keysMonth} disabled={ this.checkMonthDisabled(keysMonth) } >{valueMonth}</Option>
									)
								}
							</Select>
						</div>
					}
					<div>
						<Text>
							เลือกปี
						</Text>
						<Select
							defaultValue={selectYear}
							style={{ width: '100%' }}
							onChange={this.onChangeYear}
						>
                     {
                        ListUrlTaxKey == '1' ?
                           dropDownMasterSlipPayment.map((values,keys)=>
                              <Option value={values.id - 543}>{values.label}</Option>
                           )
                        :
                        
                            optionDropDownYear.map((values,keys)=>
                              <Option value={values.id}>{values.label}</Option>
                           )
                     }
						</Select>
					</div>
			</Modal>
		</>
	}

	detailMoneyMonth = (value, title) => {
		return <>
			<Row>
				<Col xs={24} md={18}>
					<Text className="">
						{title}
					</Text>
				</Col>
				<Col xs={24} md={6} align="right">
					{numberWithCommas(value.toFixed(2).toString())}
				</Col>
			</Row>
		</>
	}

	detailMoneyMonthArray = (valueSlip, title, keysNumber) => {
		return valueSlip.map((valueDetail, keys) =>
			<Row>
				<Col xs={24} md={18}>
					<Text className="">
						{valueDetail.name}
					</Text>
				</Col>
				<Col xs={24} md={6} align="right">
					{numberWithCommas(valueDetail.value.toFixed(2).toString())}
				</Col>
			</Row>
		)
	}

	onChangeInputCardId = ({ target: { value } }) => {
		this.setState({
			CardNoValue: value
		});
	};

	fetchSalaryCertCheck = async () =>{
		const { client } = this.props
		const { profileKey, CardNoValue } = this.state
		try {

			const { data, errors } = await client.query({
				query: Queries.fetchSalaryCert,
				variables: {
					identityCard: CardNoValue.toString(),
					profileKey
				}
			})

			if(data.fetchSalaryCert){
				return true
			}else{
				return false
			}
		} catch (error) {
			// // console.log('1231321',)
			// await this.setState({
			// 	preLoadDataSlip: true,
			// 	// textPayrollSlip: null
			// })
		}
	}

	onOkInputCardId = async ({ target: { value } }) => {
		const { ListUrlTaxKey, CardNoValue } = this.state
		let checkPasswords = await this.fetchSalaryCertCheck()
		if(checkPasswords){
			await this.setState({
				visibleModalCardNo: false,
				ModalCardNoPreLoad:false
			})
			await this.fetchSlipPayDate().then(async() => {
				await this.dropDownSlipPayment().then(async()=>{
					await this.setState({
						CardNoOk: true,
						CardNoFetch: CardNoValue,
						preLoadDataSlip: true,
						ModalCardNoPreLoad:true
					})
					// if(ListUrlTaxKey == '0'){
					// 	await this.fetchSlip()
					// }else if(ListUrlTaxKey == '1'){
					// 	await this.fetchSlip('12')
					// }else if(ListUrlTaxKey == '2'){
					// 	await this.fetchSlip()
					// }else if(ListUrlTaxKey == '3'){
					// 	await this.fetchSlip('6')
					// }else if(ListUrlTaxKey == '4'){
					// 	await this.fetchSlip('12')
					// }
				})
			 })
		}else{
			const { client } = this.props
			const { profileKey, CardNoValue } = this.state

			await this.setState({
				visibleModalCardNo: false,
				ModalCardNoPreLoad:false
			})
			const { data, errors } = await client.query({
				query: Queries.fetchSalaryCert,
				variables: {
					identityCard: CardNoValue.toString(),
					profileKey
				}
			})
		
			if(data == null) {
				if (errors[0].extensions.code == 'SALARY_NOT_FOUND') {
					await this.setState({
						CardNoFetch: true,
						CardNoOk: true,
					})
					return false
				} else {
					if(data.fetchSalaryCert) {
						await this.setState({
							visibleModalCardNo: false,
							ModalCardNoPreLoad:true
						})
					}
				}
			}
		}
		
	};

	handleCancelCardId = () => {
		this.setState({
			visibleModalCardNo: false,
			ModalCardNoPreLoad: true
		});
	};

	changeProfileKey = async (e) =>{
		const { selectOrganization } = this.state

		await this.setState({
			preLoadDataSlip: false,
			listUrlTax: [],
			textMonthOrYear: 'เดือน',
			selectTypeSalaryCert: null,
			dropDownTypeSalaryCert: null,
			detaSalaryCertText: null,
			switchShowMonthOrSalarCert: null
		})

		await selectOrganization.filter(selectOrganization => selectOrganization.profileKey == e.target.value).map(async filterData => (
			await this.setState({
				organizationName: filterData.workProfile.orgPosition.positionName+' '+filterData.workProfile.orgUnit.orgUnitName+' '+filterData.workProfile.organization.orgName,
				profileKey: e.target.value,
				ListUrlTaxKey: '',
			},async ()=>{
				let checkPasswords = await this.fetchSalaryCertCheck()
				if (checkPasswords) {
				await this.dropDownSlipPayment().then(async()=>{
					await this.setState({
						preLoadDataSlip: true,
					})
					// await this.fetchSlip()
				})
				} else{
					const { client } = this.props
					const { profileKey, CardNoValue } = this.state
		
					await this.setState({
						visibleModalCardNo: false,
						ModalCardNoPreLoad:false
					})
					const { data, errors } = await client.query({
						query: Queries.fetchSalaryCert,
						variables: {
							identityCard: CardNoValue.toString(),
							profileKey
						}
					})
				
					if(data == null) {
						if (errors[0].extensions.code == 'SALARY_NOT_FOUND') {
							await this.setState({
								CardNoFetch: true,
								CardNoOk: true,
								preLoadDataSlip: true
							})
							return false
						}
					} else {
						if(data.fetchSalaryCert) {
							await this.setState({
								visibleModalCardNo: false,
								ModalCardNoPreLoad:true
							})
							await this.fetchSlipPayDate().then(async() => {
								await this.dropDownSlipPayment().then(async()=>{
									await this.setState({
										CardNoOk: true,
										CardNoFetch: CardNoValue,
										preLoadDataSlip: true,
										ModalCardNoPreLoad:true
									})
								})
							})
						}
					}	
				}
                // await this.fetchSlip()
				// await this.fetchSlipPayDate()
            })
		))
	}

	dropDownSlipPayment = async()=>{
		const { client } = this.props
		const { profileKey } = this.state
		try {
			const { selectMonth, selectYear, CardNoValue } = this.state
			// console.log("CardNoValue.toString()", CardNoValue.toString());

			const { data, errors } = await client.query({
				query: Queries.dropDownSlipPayment,
				variables: {
					month: selectMonth.toString(),
					year: selectYear.toString(),
					profileKey
				}
			})

			await this.setState({
				listUrlTax: data.dropDownSlipPayment,
			})
			
		} catch (error) {
			
		}
	}

	fetchConditionSalaryCertText = async ()=>{
		const { client } = this.props
		const { profileKey, CardNoValue, ListUrlTaxKey } = this.state
		try {

         if(ListUrlTaxKey == '5'){
            const { data, errors } = await client.query({
               query: Queries.fetchConditionSalaryCertText,
               variables: {
                  profileKey
               }
            })
   
            await this.setState({
               detaSalaryCertText: data.fetchConditionSalaryCertText,
               // textPayrollSlip: null
            })
         }else if(ListUrlTaxKey == '6'){
            const { data, errors } = await client.query({
               query: Queries.fetchConditionSalaryCertForBankText,
               variables: {
                  profileKey
               }
            })
   
            await this.setState({
               detaSalaryCertText: data.fetchConditionSalaryCertForBankText,
               // textPayrollSlip: null
            })
         }
			

		} catch (error) {
			
		}
	}

	fetchSalaryCert = async () =>{
		const { client } = this.props
		const { profileKey, CardNoValue, ListUrlTaxKey } = this.state
		await this.setState({
			preLoadDataSlip: false,
			detailSlip:null
		})
		try {
         let detailFetch = null

         // if(ListUrlTaxKey == '5'){
            const { data, errors } = await client.query({
               query: Queries.fetchSalaryCert,
               variables: {
                  identityCard: CardNoValue.toString(),
                  profileKey
               }
            })
            
            detailFetch = data
         // }else if(ListUrlTaxKey == '6'){
         //    const { data, errors } = await client.query({
         //       query: Queries.fetchSalaryCert,
         //       variables: {
         //          identityCard: CardNoValue.toString(),
         //          profileKey
         //       }
         //    })

         //    detailFetch = data
         // }

			

			if(detailFetch.fetchSalaryCert){
				await this.setState({
					detaSalaryCert: detailFetch.fetchSalaryCert,
					dropDownSalaryCert: detailFetch.fetchSalaryCert.dropdownLang,
					switchShowMonthOrSalarCert: 'Salary',
					preLoadDataSlip: true,
					// textPayrollSlip: null
				})
	
				await this.fetchConditionSalaryCertText()
			}else{
				console.log('')
				await this.setState({
					preLoadDataSlip: true,
					// textPayrollSlip: null
				})
			}
			
			//await this.onChangeSalaryCert('TH')
			
		} catch (error) {
			// console.log('1231321',)
			await this.setState({
				preLoadDataSlip: true,
				// textPayrollSlip: null
			})
		}
	}

	onChangeListUrlTax = async (e) =>{
		let textMonthOrYear = 'เดือน';
		console.log('xxzzzxxx',e)

		if(e){
			if(e == '1' || e == '3' || e == '4'){
				textMonthOrYear = 'ปี'
			}
			
			await this.setState({
				ListUrlTaxKey: e,
				textMonthOrYear,
				detaSalaryCert: null,
				dropDownSalaryCert: [],
				linkPDFSalary: null,
				selectTypeSalaryCert: null,
				dropDownTypeSalaryCert: null,
				dropdownSelectedDocType: null
				// selectYear: moment().year()
			})

			await this.fetchSlipPayDate()
	
			if(e == '0'){
				await this.fetchSlip()
			}else if(e == '1'){
				await this.setState({
					selectYear: moment().add('-1', 'year').year()
				})

            await this.dropDownMasterSlipPayment(e)
				await this.fetchSlip('1-12')
			}else if(e == '2'){
				await this.fetchSlip()
			}else if(e == '3'){
				// await this.fetchSlip('6')
				await this.fetchSlip('1-6')
			}else if(e == '4'){
				// await this.fetchSlip('12')
				await this.fetchSlip('7-12')
			}else if(e == '5'){
            await this.setState({
               labelDropdownFile: "กรุณาเลือกประเภทหนังสือรับรองเงินเดือน"
            })
				await this.fetchDropDownTypeSalaryCert()
				await this.fetchSalaryCert()
			}else if(e == '6'){
            await this.setState({
               labelDropdownFile: "กรุณาเลือกใบผ่านสิทธิ์ธนาคารออมสิน"
            })
            await this.fetchdropDownTypeSalaryCertForBank()
				await this.fetchSalaryCert()
         }
		 await this.setState({
			dropdownSelectedDocType: e
		 })
		}
		// await this.fetchSlip()
	}

   fetchdropDownTypeSalaryCertForBank = async() =>{
		const { client } = this.props
		const { profileKey } = this.state

		const { data, errors } = await client.query({
			query: Queries.dropDownTypeSalaryCertForBank,
			variables: {
				profileKey,
			}
		})

		if(data.dropDownTypeSalaryCertForBank){
			await this.setState({
				dropDownTypeSalaryCert: data.dropDownTypeSalaryCertForBank,
			})
		}else{
			await this.setState({
				dropDownTypeSalaryCert: null,
			})
		}
		
		// console.log('onChangeSalaryCert', values)
	}

	checkButtonSlip = () =>{
		const { ListUrlTaxKey, selectYear, selectMonth } = this.state
		console.log('selectMonth',selectMonth)
		
		if(ListUrlTaxKey == '1'){
			return 'show'
		}else if(ListUrlTaxKey == '4'){
			return 'show'
		}else{
			return 'show'
		}
	}

	onChangeTypeSalartCert = async (value) => {
		const { selectTypeSalaryCert, ListUrlTaxKey } = this.state

		await this.setState({
			selectTypeSalaryCert: value,
			linkPDFSalary: null,
			preLoadSlipSalartCert: true
		})


      if(ListUrlTaxKey == '5'){
         await this.onChangeSalaryCert('TH')
      }else if(ListUrlTaxKey == '6'){
         await this.fetchUrlSalaryCertForBank('TH')
      }
	}

   fetchUrlSalaryCertForBank = async(lang) =>{
		const { client } = this.props
		const { profileKey, selectTypeSalaryCert, empCode } = this.state

		const { data, errors } = await client.query({
			query: Queries.fetchUrlSalaryCertForBank,
			variables: {
				documentType: selectTypeSalaryCert,
				empCode,
				profileKey,
			}
		})

		if(data.fetchUrlSalaryCertForBank.linkPDF){
			await this.setState({
				linkPDFSalary: data.fetchUrlSalaryCertForBank.linkPDF,
				preLoadSlipSalartCert: false
			})
		}else{
			await this.setState({
				linkPDFSalary: null,
				preLoadSlipSalartCert: false
			})
		}
		
		// console.log('onChangeSalaryCert', values)
	}

	fetchDropDownTypeSalaryCert = async() =>{
		const { client } = this.props
		const { profileKey } = this.state

		const { data, errors } = await client.query({
			query: Queries.dropDownTypeSalaryCert,
			variables: {
				profileKey,
			}
		})

		console.log('data.dropDownTypeSalaryCert',data.dropDownTypeSalaryCert)

		if(data.dropDownTypeSalaryCert){
			await this.setState({
				dropDownTypeSalaryCert: data.dropDownTypeSalaryCert,
			})
		}else{
			await this.setState({
				dropDownTypeSalaryCert: null,
			})
		}
		
		// console.log('onChangeSalaryCert', values)
	}

	onChangeSalaryCert = async(lang) =>{
		const { client } = this.props
		const { profileKey, selectTypeSalaryCert, empCode } = this.state

		const { data, errors } = await client.query({
			query: Queries.fetchUrlSalaryCert,
			variables: {
				documentType: selectTypeSalaryCert,
				empCode,
				profileKey,
			}
		})

		console.log('data.fetchUrlSalaryCert',data.fetchUrlSalaryCert)

		if(data.fetchUrlSalaryCert.linkPDF){
			await this.setState({
				linkPDFSalary: data.fetchUrlSalaryCert.linkPDF,
				preLoadSlipSalartCert: false
			})
		}else{
			await this.setState({
				linkPDFSalary: null,
				preLoadSlipSalartCert: false
			})
		}
		
		// console.log('onChangeSalaryCert', values)
	}


   dropDownMasterSlipPayment = async(docGroup, type = 2) =>{
		const { client } = this.props

		const { data, errors } = await client.query({
			query: Queries.dropDownMasterSlipPayment,
			variables: {
				docGroup: "0"+docGroup,
				type,
			}
		})

      await this.setState({
         dropDownMasterSlipPayment: data.dropDownMasterSlipPayment,
         selectYear: data.dropDownMasterSlipPayment?.length > 0 ? data.dropDownMasterSlipPayment[0].id-543 : ""
      })

      console.log('dropDownMasterSlipPayment', data.dropDownMasterSlipPayment?.length > 0 ? data.dropDownMasterSlipPayment[0].id : "")
	}


	async componentDidMount() {
		setTimeout(async() =>{ 
			await this.fetchHowToOpenPayrollSlip()
			await this.accordingProfile()
			await this.fetchProfile()
			await this.setState({
				visibleModalCardNo:true
			})
		}, 3000);
       
		// await this.fetchUrlTaxYears()
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.CardNoFetch !== this.state.CardNoFetch) {
			this.setState({
				preLoad: true
			})
		}
	}

	render() {
		const { history, location, match, staticContext } = this.props
		const { selectMonth, 
				selectYear, 
				detailSlip, 
				visibleModalCardNo, 
				ModalCardNoPreLoad, 
				preLoadDataSlip, 
				CardNoOk, 
				CardNoFetch, 
				preLoad, 
				textPayrollSlip, 
				profileKey,
				selectOrganization,
				textMonthOrYear,
				ListUrlTaxKey,
				listUrlTax,
				switchShowMonthOrSalarCert,
				detaSalaryCert,
				dropDownSalaryCert,
				linkPDFSalary,
				detaSalaryCertText,
				dropDownTypeSalaryCert,
				selectTypeSalaryCert,
				preLoadSlipSalartCert,
            	labelDropdownFile,
            	dropDownMasterSlipPayment,
				dropdownSelectedDocType
			} = this.state

			console.log('dropDownTypeSalaryCert',dropDownTypeSalaryCert)
			// console.log('preLoadDataSlip',preLoadDataSlip)
		return (
			<Container match={match}>
				{
					visibleModalCardNo &&
					<Modal
						visible={visibleModalCardNo}
						title="รหัสผ่าน"
						onCancel={this.handleCancelCardId}
						footer={[
							<>
								<Button key="submit" type="primary" className="color-white" onClick={this.onOkInputCardId}>
									ตกลง
									</Button>
								<Button key="submit" onClick={this.handleCancelCardId}>
									ยกเลิก
								</Button>
							</>
						]}
					>
						<Text>กรุณากรอกรหัสผ่าน (รหัสที่ใช้เข้าสู่ระบบ)</Text>
						<Input.Password type="password" maxLength="100" onBlur={this.onChangeInputCardId} />
					</Modal>
					||
					(CardNoFetch && CardNoOk) &&
						<div className="card-container" id="page-slip">
							<Row className="mb-3">
								<Col xs={24} >
									{/* <CardTitle title="รายได้ของท่าน" subtitle="E-pay Slip" ></CardTitle> */}
									<CardTitle title="เอกสารเกี่ยวกับเงินได้" subtitle="Income Document" ></CardTitle>
									{/* test { selectMonth } */}
								</Col>
							</Row>
							<Row>
								<Col>
									<div style={{ width: "100%" }} className="mb-3">
										{
		                                    selectOrganization.length !== 0  &&
											<>
												<label>กรุณาเลือกหน่วยงานที่ท่านปฏิบัติงาน :</label>
												 <Radio.Group  defaultValue={profileKey} style={{ width:"100%" }} onChange={this.changeProfileKey}>
													{
														selectOrganization.map(item => (
															<Radio style={radioStyle} value={item.profileKey}>
																{ item.workProfile.orgPosition.positionName+' '+item.workProfile.orgUnit.orgUnitName+' '+item.workProfile.organization.orgName }
															</Radio>
														))
													}
												</Radio.Group>
											</>
										}
									</div>
								</Col>
							</Row>
							<Row>
								{
									preLoadDataSlip &&
									<>
										<Col xs={24} md={14}>
											<div className="mb-3">
												<label>กรุณาเลือกเอกสาร :</label>
												<Select 
													// defaultValue={ListUrlTaxKey} 
													value={ ListUrlTaxKey }
													style={{ width:"100%" }} 
													onChange={this.onChangeListUrlTax}
													placeholder="กรุณาเลือกเอกสาร"
												>

														<Select.Option key={''} value={''} disabled={true}>
															กรุณาเลือกเอกสาร
														</Select.Option>
													{
														listUrlTax.map(item => (
															<Select.Option key={item.id} value={item.id}>
																{ item.label }
															</Select.Option>
														))
													}
												</Select>
											</div>
											<div>
												{
													switchShowMonthOrSalarCert == 'Salary' &&
													<Card className="mb-3">
														<div 
															className="mt-2 custom-textslip custom-width-tooltip" 
															// style={{ width: "240px"}} 
															dangerouslySetInnerHTML={{ __html: convertToHTMl(detaSalaryCertText ? detaSalaryCertText : '') }}
															// dangerouslySetInnerHTML={{ __html: convertToHTMl("กรณีเงื่อนไขต่อไปนี้กรุณาติดต่อเจ้าหน้าที่ทรัพยากรบุคคล\n- ยังไม่รองรับการออกหนังสือรับรองให้ตำแหน่ง ที่ปรึกษา, ผู้เชี่ยวชาญ เป็นต้น\n- ออกให้เฉพาะบุคลากร / ลูกจ้างที่ผ่านการทดลองงาน\n") }}

														/> 
														{/* {detaSalaryCertText} */}
													</Card>
												}
											</div>
											{
												ListUrlTaxKey !== '0' &&
													<div></div>
												|| detailSlip &&
												<Card className="mb-3">
													<div className="mt-4">
														<Row>
															<Col xs={24} md={18}>
																<Text className="">
																	วันที่จ่ายเงิน
																</Text>
															</Col>
															<Col xs={24} md={6} align="right">
															{ changeFormatdateSlip(moment(detailSlip.paymentDate)) }
															</Col>
														</Row>
													</div>
													<div className="mb-3">
														<Title level={4}>
															รายการเงินได้(บาท)
														</Title>
														{
															detailSlip.income &&
															<>
																{this.detailMoneyMonthArray(detailSlip.income.lists)}
																{this.detailMoneyMonth(detailSlip.income.total, 'รวมเงินได้ทั้งสิ้น')}
															</>
														}
													</div>
													<div>
															<Title level={4}>
																รายการเงินที่ต้องหักจากรายได้(บาท)
															</Title>
														{
															detailSlip.expense &&
															<>
																{this.detailMoneyMonthArray(detailSlip.expense.lists)}
																{this.detailMoneyMonth(detailSlip.expense.total, 'รวมเงินที่ต้องหักจากเงินได้ทั้งสิ้น')}
															</>
														}

														<br></br>
														{
															detailSlip.income &&
															<>
																{this.detailMoneyMonth(detailSlip.income.totalPerMonth, 'รายได้สุทธิประจำเดือน')}
																{this.detailMoneyMonth(detailSlip.income.totalPerYear, 'เงินได้สะสมตั้งแต่ต้นปี')}
															</>
														}
                                          
                                          {
															detailSlip.expense &&
															<>
																{this.detailMoneyMonth(detailSlip.expense.withholdingTax, 'ภาษีหัก ณ ที่จ่ายสะสมตั้งแต่ต้นปี')}
															</>
														}
													</div>
												</Card>
												||
												<Card>
													<Col span={24}>
														<Title level={4} className="mb-0" align="center">
															-- ไม่พบข้อมูลในเดือน { changeOnlyMonthSlip(selectMonth) } { changeYear(selectYear) } --
														</Title>
													</Col>
												</Card>
											}
										</Col>
										<Col xs={24} md={9} offset={1} className="mb-4">
											{
												ListUrlTaxKey &&
												<>
													<div className="mb-3 ">
														{
															switchShowMonthOrSalarCert == 'Month' &&
																<>
																	<label>กรุณาเลือก{ textMonthOrYear }  :</label>
																	<Button type="primary" onClick={this.showModal} className="custom-buttom-padding bg-color month-btn-fick" style={{ width: "240px", display:"block" }}>
                                                      {
                                                         textMonthOrYear == 'เดือน' &&
                                                         <span className="mr-1">{ changeOnlyMonthSlip(selectMonth) }</span>
                                                      }
                                                         {changeYear(selectYear)} <Icon type="calendar" className="color-red ml-5 icons-custom-bt" />
																	</Button>
																</>
															||
																<>
																	{
																		detaSalaryCert &&
																			<>
																				<div className="mb-4">
																					<Text>
																						{labelDropdownFile}
																					</Text><br></br>
																					<Select
																						// defaultValue={moment(selectMonth).month()}
																						defaultValue=''
																						style={{ width: '100%' }}
																						onChange={this.onChangeTypeSalartCert}
																						disabled ={detaSalaryCert.isDisable}
																						placeholder={labelDropdownFile}
																					>
																						<Select.Option key={''} value={''} disabled={true}>
																							{labelDropdownFile}
																						</Select.Option>
																						{
																							dropDownTypeSalaryCert &&
																							dropDownTypeSalaryCert.map((value) =>
																								<Option value={value.id} >{value.label}</Option>
																							)
																						}
																					</Select>
																				</div>
																				<div className="mt-3">
																					<Button
																						type="primary"
																						className="custom-buttom-padding color-white mr-3"
																						style={{ width: "240px" }}
																						onClick={ () => window.open(linkPDFSalary, '_blank')}
																						disabled={ selectTypeSalaryCert && linkPDFSalary ? false : true || detaSalaryCert.isDisable}
																						// disabled={ this.checkButtonSlip() == 'show' ? false : true }
																						// disabled={ detaSalaryCert ? detaSalaryCert.isDisable ? true : false : false }
																					>
																						แสดงเอกสาร <Icon type="file-pdf" className="ml-5 icons-custom-bt" />
																					</Button>
																					{
																						preLoadSlipSalartCert &&
																							<Spin />
																					}
																				</div>
																			</>
																	}
																	
																</>
														}
														
														{this.modalSelectMonth()}
													</div>
													<div className="mb-3">
														{
															detailSlip &&
															<Button
																type="primary"
																className="custom-buttom-padding color-white"
																style={{ width: "240px" }}
																onClick={this.fetchSlipOpenLink}
																// disabled={ detailSlip ? false : true }
																disabled={ this.checkButtonSlip() == 'show' ? false : true }
															>
																แสดงเอกสาร <Icon type="file-pdf" className="ml-5 icons-custom-bt" />
															</Button>
														}

														{
															detaSalaryCert ?
																!detaSalaryCert.isDisable &&
																<div className="mt-3">
																	<div 
																		className="mt-2 custom-textslip custom-width-tooltip custom-textslip-p" 
																		style={{ width: "240px"}} 
																		dangerouslySetInnerHTML={{ __html: convertToHTMl(textPayrollSlip ? textPayrollSlip : '') }}
																	/> 
																</div>
															:
																<div className="mt-3">
																	<div 
																		className="mt-2 custom-textslip custom-width-tooltip custom-textslip-p" 
																		style={{ width: "240px"}} 
																		dangerouslySetInnerHTML={{ __html: convertToHTMl(textPayrollSlip ? textPayrollSlip : '') }}
																	/> 
																</div>
														}
														
														
														{/* {this.modalSelectMonth()} */}
													</div>
												</>
											}
											
										</Col>
									</>
									||
									<Card>
										<Col span={24} align="center">
											<Spin />
										</Col>
									</Card>
								}
							</Row>
						</div>
					||
					
					!ModalCardNoPreLoad &&
						<div align="center">
							<Spin />
						</div>
					||
					<>
						<Title level={4}>ไม่สามารถแสดงข้อมูลได้</Title>
						<Button
							type="primary"
							className="color-white"
							onClick={() => {
								this.setState({
									visibleModalCardNo: true
								})
							}}
						>
							แสดงเอกสารเกี่ยวกับเงินได้
						</Button>
					</>
				}
			</Container>
		)
	}
}

Slip.propTypes = {
	//
}

export default withApollo(Slip)
